module.exports = __webpack_public_path__ + "static/media/emilie-icon.41256c85.png";